import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useEdc } from '../edc/EdcContext';

export default function SitemarkIcon() {
  const { edcMode } = useEdc();

  if (edcMode) {
    return (
      <Box
        sx={{
          display: 'inline-flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          lineHeight: 1,
          marginRight: '10px',
          marginBottom: '5px',
        }}
      >
        <Typography
          component="span"
          className="edc-title"
          sx={{
            fontSize: { xs: '0.7rem', sm: '0.85rem' },
            fontWeight: 900,
            letterSpacing: '0.12em',
            lineHeight: 1,
            whiteSpace: 'nowrap',
          }}
        >
          HEADBANGER UNION LOCAL 808
        </Typography>
      </Box>
    );
  }

  return (
    <img
      src="https://images.ctfassets.net/zw84cuagwed8/38Y6tWfXyaveO0gxEtlfmJ/27e92a2d8cdd963afc56b5b3465fa7c7/98794ed8-2649-416e-b548-7a7d7a6b210d.png"
      alt="Sitemark"
      style={{
        height: 25,
        width: 100,
        marginRight: 10,
        marginBottom: 5,
      }}
    />
  );
}
